// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__MGpdZ","colMaxWidth":"Table_colMaxWidth__3kzQD"};